module.exports = __webpack_public_path__ + "img/ic_checkbox-active.916aa4b4.svg";